<template>
    <div class="unit-editor">
      <!-- Top bar -->
      <header class="topbar">
        <img
          src="@/assets/logogruas.png"
          alt="HomePage"
          class="logo-button"
          @click="backMainPanel"
        />
  
        <div class="topbar-title">
          <div class="kicker">Mantenimiento</div>
          <h1>Nueva unidad</h1>
          <p class="subtitle">
            {{ unit_short_id || "—" }} · {{ unit_plates || "Sin placas" }}
          </p>
        </div>
  
        <div class="topbar-actions">
          <button class="btn ghost" type="button" @click="goBack" :disabled="saving_unit">
            Cancelar
          </button>
          <button
            v-if="canCreateUnit"
            class="btn primary"
            type="button"
            @click="saveUnit"
            :disabled="saving_unit || !isFormValid"
          >
            <span v-if="!saving_unit">Guardar</span>
            <span v-else>Guardando…</span>
          </button>
        </div>
      </header>
  
      <!-- Tabs -->
      <div class="tabs-wrap">
        <nav class="tabs">
          <button
            v-for="t in visibleTabs"
            :key="t.key"
            class="tab"
            :class="{ active: activeTab === t.key }"
            @click="activeTab = t.key"
          >
            <span class="tab-label">{{ t.label }}</span>
            <span class="tab-hint" v-if="t.hint">{{ t.hint }}</span>
          </button>
        </nav>
  
        <div class="tab-panel">
          <section v-if="activeTab === 'general'">
            <div class="main-data-container">
              <div class="maintenance-main">
                <div class="container-card">
                  <div class="section-title maintenance-title-row">
                    <h4>Datos de la unidad</h4>
                  </div>
                  <div class="container-card-body">
                    <div class="form-grid">
              <div class="field">
                <label class="field-label">ID</label>
                <div class="field-control">
                  <input type="text" placeholder="Introduce el ID de la unidad" v-model.trim="unit_id" />
                </div>
              </div>
  
              <div class="field">
                <label class="field-label"># Económico</label>
                <div class="field-control">
                  <input type="text" placeholder="Introduce el número económico" v-model.trim="unit_short_id" />
                </div>
              </div>
  
              <div class="field">
                <label class="field-label">Tipo unidad</label>
                <div class="field-control">
                  <select v-model="unit_type">
                    <option disabled value="">—</option>
                    <option :value="1">CAJA SECA</option>
                    <option :value="2">INDUSTRIALES</option>
                    <option :value="3">MONTACARGAS</option>
                    <option :value="4">NODRIZAS</option>
                    <option :value="5">PARTICULARES</option>
                    <option :value="6">PLATAFORMAS Y LOW BOYS</option>
                    <option :value="7">RAMPAS</option>
                    <option :value="8">RAMPAS 4 CARROS</option>
                    <option :value="9">RAMPAS GRANDES</option>
                    <option :value="10">REMOLQUES CHICOS</option>
                    <option :value="11">REMOLQUES GRANDES</option>
                    <option :value="12">REPARTO</option>
                    <option :value="13">TITANES</option>
                    <option :value="14">TRACTORES</option>
                    <option :value="15">Rescate</option>
                    <option :value="16">AUXILIO VIAL</option>
                  </select>
                </div>
              </div>
  
              <div class="field">
                <label class="field-label">Categoría</label>
                <div class="field-control">
                  <select v-model="unit_category">
                    <option disabled value="">—</option>
                    <option :value="1">Categoría A</option>
                    <option :value="2">Categoría B</option>
                    <option :value="3">Categoría C</option>
                    <option :value="4">Categoría D</option>
                    <option :value="5">AUXILIO VIAL</option>
                    <option :value="6">MONTACARGAS</option>
                    <option :value="7">NO APLICA</option>
                  </select>
                </div>
              </div>
  
              <div class="field">
                <label class="field-label">Marca</label>
                <div class="field-control">
                  <select v-model="unit_brand">
                    <option value="1">Hino</option>
                    <option value="2">Volkswagen</option>
                    <option value="3">Dodge</option>
                    <option value="4">Freightliner</option>
                    <option value="5">Mercedez Benz</option>
                    <option value="6">KENWORTH</option>
                    <option value="7">Nissan</option>
                    <option value="8">Vento</option>
                    <option value="9">Honda</option>
                    <option value="10">Toyota</option>
                    <option value="11">Zoomlion</option>
                    <option value="12">Hyster</option>
                    <option value="13">Taylor</option>
                    <option value="14">Heli</option>
                    <option value="15">CHL</option>
                    <option value="16">AYUDANTE</option>
                    <option value="18">SANY</option>
                    <option value="19">Bombardier</option>
                    <option value="20">Buick</option>
                    <option value="21">BYD</option>
                    <option value="22">Chevrolet</option>
                    <option value="23">Clark</option>
                    <option value="24">Cupra</option>
                    <option value="25">Eager Beaver</option>
                    <option value="26">Fegar</option>
                    <option value="27">Grove</option>
                    <option value="28">HINO</option>
                    <option value="29">Kaufman</option>
                    <option value="30">KIA</option>
                    <option value="31">Mitsubishi</option>
                    <option value="32">Natsa</option>
                    <option value="33">Polaris</option>
                    <option value="34">P&H</option>
                    <option value="35">Ramirez</option>
                    <option value="36">Sterling</option>
                    <option value="37">Trail King</option>
                    <option value="38">Versa-Lift</option>
                    <option value="39">WABA</option>
                    <option value="40">NO APLICA</option>
                  </select>
                </div>
              </div>
  
              <div class="field">
                <label class="field-label">Sub marca</label>
                <div class="field-control">
                  <select v-model="unit_sub_brand">
                    <option value="716 SUPERLONG">716 SUPERLONG</option>
                    <option value="FL-M2-106-25K-15">FL-M2-106-25K-15</option>
                    <option value="M2106 35K EUROV">M2106 35K EUROV</option>
                    <option value="FL-M2-106-16">FL-M2-106-16</option>
                    <option value="CL120">CL120</option>
                    <option value="M2 35K">M2 35K</option>
                    <option value="FL-M2-35K-12">FL-M2-35K-12</option>
                    <option value="816 SUPERLONG">816 SUPERLONG</option>
                    <option value="CASCADIA DD15">CASCADIA DD15</option>
                    <option value="716 SUPER LONG">716 SUPER LONG</option>
                    <option value="RAM 4000">RAM 4000</option>
                    <option value="TIPO T800B">TIPO T800B</option>
                    <option value="M2 106 25K">M2 106 25K</option>
                    <option value="FL360 2528">FL360 2528</option>
                    <option value="Modelo 9.170 4X2">Modelo 9.170 4X2</option>
                    <option value="Modelo 9.170 DELIVERY">Modelo 9.170 DELIVERY</option>
                    <option value="CL120 COLUMBIA">CL120 COLUMBIA</option>
                    <option value="TIPO T800B">TIPO T800B</option>
                    <option value="RAM 4000 GASOLINA">RAM 4000 GASOLINA</option>
                    <option value="M2 33K">M2 33K</option>
                    <option value="M2 25K">M2 25K</option>
                    <option value="Modelo 9.170 DELIVERY 4x2">Modelo 9.170 DELIVERY 4x2</option>
                    <option value="RAM 4000  DIESEL">RAM 4000  DIESEL</option>
                    <option value="FL360">FL360</option>
                    <option value="KENMEX 5a. RUEDA">KENMEX 5a. RUEDA</option>
                    <option value="March">March</option>
                    <option value="Moto">Moto</option>
                    <option value="GL150 CARGO">GL150 CARGO</option>
                    <option value="8FDU30"> 8FDU30</option>
                    <option value="7FDU70"> 7FDU70</option>
                    <option value="02-7FD40"> 02-7FD40</option>
                    <option value="FD35Z"> FD35Z</option>
                    <option value="FD50"> FD50</option>
                    <option value="FD70"> FD70</option>
                    <option value="H280XL"> H280XL</option>
                    <option value="FD35"> FD35</option>
                    <option value="FD50"> FD50</option>
                    <option value="FD70"> FD70</option>
                    <option value="T360L"> T360L</option>
                    <option value="T360L"> T360L 36,000 LBS</option>
                    <option value="FD160"> FD160</option>
                    <option value="CPCD70-W2G"> CPCD70-W2G</option>
                    <option value="CPQYD50-KUG3"> CPQYD50-KUG3</option>
                    <option value="CPCD100-W5G"> CPCD100-W5G</option>
                    <option value="CPCD35-W4H"> CPCD35-W4H</option>
                    <option value="CPQYD50-KU2K2C">CPQYD50-KU2K2C</option>
                    <option value="CPCD70-W2K2"> CPCD70-W2K2</option>
                    <option value="CPCD40-M4K2"> CPCD40-M4K2</option>
                    <option value="CPQYD40-KU2K2"> CPQYD40-KU2K2</option>
                    <option value="HQC42503SWS12E - 2024"> HQC42503SWS12E - 2024</option>
                    <option value="HQC343DE2 - 2024">HQC343DE2 - 2024</option>
                    <option value="11.180 DELIVERY 4X2">11.180 DELIVERY 4X2</option>
                    <option value="17.230 4X2 ROBUST (CONSTELATION)">17.230 4X2 ROBUST (CONSTELATION)</option>
                    <option value="25/35E 35,000 LBS">25/35E 35,000 LBS</option>
                    <option value="7FGAU50">7FGAU50</option>
                    <option value="818 SUPER LONG EURO 6">818 SUPER LONG EURO 6</option>
                    <option value="9.180 DELIVERY E6 4X2">9.180 DELIVERY E6 4X2</option>
                    <option value="AT4425G">AT4425G</option>
                    <option value="BLAZER C RS">BLAZER C RS</option>
                    <option value="CRF125FB">CRF125FB</option>
                    <option value="CB160F">CB160F</option>
                    <option value="CMP25">CMP25</option>
                    <option value="CMP40D">CMP40D</option>
                    <option value="CMP75SE">CMP75SE</option>
                    <option value="CRV TOURING CVT">CRV TOURING CVT</option>
                    <option value="DUTRO 300">DUTRO 300</option>
                    <option value="ENCORE GX SPORT TOURING">ENCORE GX SPORT TOURING</option>
                    <option value="FRONTIER V6 CREW CAB PRO-4X 4X2 T/A">FRONTIER V6 CREW CAB PRO-4X 4X2 T/A</option>
                    <option value="GLB 220 4MATIC MH">GLB 220 4MATIC MH</option>
                    <option value="HIGHLANDER">HIGHLANDER</option>
                    <option value="HILUX CABINA SENCILLA">HILUX CABINA SENCILLA</option>
                    <option value="HRV PRIME">HRV PRIME</option>
                    <option value="HRV SPORT">HRV SPORT</option>
                    <option value="KODIAK SERIE 6">KODIAK SERIE 6</option>
                    <option value="L200 GLS PICK UP DOB CAB 4X4 AT DIESEL">L200 GLS PICK UP DOB CAB 4X4 AT DIESEL</option>
                    <option value="L200 GLX PICK UP DOB CAB 4X2 MAN">L200 GLX PICK UP DOB CAB 4X2 MAN</option>
                    <option value="L200 GLX PICK UP DOBLE CABINA 4X4">L200 GLX PICK UP DOBLE CABINA 4X4</option>
                    <option value="LEON">LEON</option>
                    <option value="M 7500 AC TERRA">M 7500 AC TERRA</option>
                    <option value="M2 106 35K">M2 106 35K</option>
                    <option value="M2 106 60K">M2 106 60K</option>
                    <option value="M2 60K">M2 60K</option>
                    <option value="MARCH ACTIVE TM AA">MARCH ACTIVE TM AA</option>
                    <option value="MARCH ACTIVE TM AA STD">MARCH ACTIVE TM AA STD</option>
                    <option value="MARCH SENSE T/M">MARCH SENSE T/M</option>
                    <option value="MARCH SENSE TM">MARCH SENSE TM</option>
                    <option value="NP300 DOBLE CABINA S TM AC">NP300 DOBLE CABINA S TM AC</option>
                    <option value="NP300 DOBLE CABINA SE AC">NP300 DOBLE CABINA SE AC</option>
                    <option value="NP300 PICK UP T/M">NP300 PICK UP T/M</option>
                    <option value="OUTLANDER MAX DPS 570">OUTLANDER MAX DPS 570</option>
                    <option value="PRIUS C">PRIUS C</option>
                    <option value="PRIUS C HATCHBACK">PRIUS C HATCHBACK</option>
                    <option value="PRIUS HYBRID">PRIUS HYBRID</option>
                    <option value="RAIZE XLE BITONO">RAIZE XLE BITONO</option>
                    <option value="RAM 700 REGULAR CAB">RAM 700 REGULAR CAB</option>
                    <option value="RGR RANGER CREW SP 570 PREMIUM">RGR RANGER CREW SP 570 PREMIUM</option>
                    <option value="SCP25C6">SCP25C6</option>
                    <option value="SIENNA HV XSE">SIENNA HV XSE</option>
                    <option value="SILVERADO DOBLE CABINA 4X2 PAQ. E WT">SILVERADO DOBLE CABINA 4X2 PAQ. E WT</option>
                    <option value="SONG PRO">SONG PRO</option>
                    <option value="SPA20AC">SPA20AC</option>
                    <option value="SPORTAGE PE2.0L LX AT">SPORTAGE PE2.0L LX AT</option>
                    <option value="STC300T5 (30 ton)">STC300T5 (30 ton)</option>
                    <option value="STC750 (75 ton)">STC750 (75 ton)</option>
                    <option value="SUBURBAN SUV">SUBURBAN SUV</option>
                    <option value="T300">T300</option>
                    <option value="T300A">T300A</option>
                    <option value="TIIDA SEDAN DRIVE T/M C/A">TIIDA SEDAN DRIVE T/M C/A</option>
                    <option value="TIIDA SEDAN SENSE T/M A/A">TIIDA SEDAN SENSE T/M A/A</option>
                    <option value="TORNADO VAN CARGO B LS">TORNADO VAN CARGO B LS</option>
                    <option value="V-DRIVE 4 PUERTAS T/M">V-DRIVE 4 PUERTAS T/M</option>
                    <option value="VENTO TIP STARLINE TIPTRONIC AUTOMÁTICO">VENTO TIP STARLINE TIPTRONIC AUTOMÁTICO</option>
                    <option value="VERSA ADVANCE CVT">VERSA ADVANCE CVT</option>
                    <option value="VERSA SENSE CVT">VERSA SENSE CVT</option>
                    <option value="VERSA SENSE TM AC">VERSA SENSE TM AC</option>
                    <option value="YARIS 5DR AT PREMIUM">YARIS 5DR AT PREMIUM</option>
                    <option value="YARIS 5DR MT CORE">YARIS 5DR MT CORE</option>
                    <option value="YARIS HB S CVT">YARIS HB S CVT</option>
                    <option value="NO APLICA">NO APLICA</option>
                  </select>
                </div>
              </div>
  
              <div class="field">
                <label class="field-label">Serie</label>
                <div class="field-control">
                  <input type="text" placeholder="Introduce la serie" v-model.trim="unit_engine_num" />
                </div>
              </div>
  
              <div class="field">
                <label class="field-label">Año modelo</label>
                <div class="field-control">
                  <input type="number" inputmode="numeric" placeholder="Ej. 2024" v-model.number="unit_model" />
                </div>
              </div>
  
              <div class="field">
                <label class="field-label">Placas</label>
                <div class="field-control">
                  <input type="text" placeholder="Introduce las placas" v-model.trim="unit_plates" />
                </div>
              </div>

              <div class="field">
                <label class="field-label">Clase</label>
                <div class="field-control">
                  <select v-model="unit_class">
                    <option disabled value="">—</option>
                    <option :value="1">Federales</option>
                    <option :value="2">Particulares</option>
                    <option :value="3">Reparto</option>
                    <option :value="4">N/A</option>
                    <option :value="5">Sitio</option>
                    <option :value="6">Discapacitado</option>
                    <option :value="7">Auxilio</option>
                  </select>
                </div>
              </div>
  
              <div class="field">
                <label class="field-label">GPS</label>
                <div class="field-control">
                  <input type="text" placeholder="Identificador GPS" v-model.trim="gps_id" />
                </div>
              </div>

              <div class="field">
                <label class="field-label">Propietario</label>
                <div class="field-control">
                  <select v-model="unit_owner">
                    <option disabled value="">—</option>
                    <option :value="1">Gruas Monterrey</option>
                    <option :value="2">Gruas Saltillo</option>
                    <option :value="3">Metrogruas</option>
                    <option :value="4">Gruas Alfa</option>
                    <option :value="5">Enzzo Industrias</option>
                    <option :value="6">Particular</option>
                  </select>
                </div>
              </div>

              <div class="field">
                <label class="field-label">Empresa asignada</label>
                <div class="field-control">
                  <select v-model="assigned_owner">
                    <option :value="null">—</option>
                    <option :value="1">Gruas Monterrey</option>
                    <option :value="2">Gruas Saltillo</option>
                    <option :value="3">Metrogruas</option>
                    <option :value="4">Gruas Alfa</option>
                    <option :value="5">Enzzo Industrias</option>
                    <option :value="6">Particular</option>
                  </select>
                </div>
              </div>

              <div class="field span-2">
                <label class="field-label">Comentarios</label>
                <div class="field-control">
                  <textarea v-model.trim="comments" placeholder="Ingrese información adicional"></textarea>
                </div>
              </div>
                    </div>
                  </div>
                </div>

                <div class="container-card">
                  <div class="section-title maintenance-title-row">
                    <h4>Administrativo</h4>
                    <div class="pill">Finanzas</div>
                  </div>
                  <div class="container-card-body">
                    <div class="form-grid">
                      <div class="field">
                        <label class="field-label">Fecha de compra</label>
                        <div class="field-control">
                          <input v-model="buy_time" type="date" />
                        </div>
                      </div>
  
                      <div class="field">
                        <label class="field-label">Valor unidad completa</label>
                        <div class="field-control">
                          <input v-model.number="current_total_value" type="number" step="0.01" inputmode="decimal" />
                        </div>
                      </div>
  
                      <div class="field">
                        <label class="field-label">Propietario en factura</label>
                        <div class="field-control">
                          <select v-model="invoice_owner">
                            <option :value="null">—</option>
                            <option :value="1">Gruas Monterrey</option>
                            <option :value="2">Gruas Saltillo</option>
                            <option :value="3">Metrogruas</option>
                            <option :value="4">Gruas Alfa</option>
                            <option :value="5">Enzzo Industrias</option>
                            <option :value="6">Particular</option>
                          </select>
                        </div>
                      </div>
  
                      <div class="field">
                        <label class="field-label">Fecha actualización de valor</label>
                        <div class="field-control">
                          <input v-model="value_update_time" type="date" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </section>
  
          <section v-else-if="activeTab === 'truck'">
            <div class="main-data-container">
              <div class="maintenance-main">
                <div class="container-card">
                  <div class="section-title maintenance-title-row">
                    <h4>Información de camión</h4>
                  </div>
                  <div class="container-card-body">
                    <div class="form-grid">
                      <div class="field">
                        <label class="field-label">Factura camión</label>
                        <div class="field-control">
                          <input v-model.trim="invoice_number" type="text" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Tipo de motor</label>
                        <div class="field-control">
                          <input v-model.trim="engine_type" type="text" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Pedimento camión</label>
                        <div class="field-control">
                          <input v-model.trim="truck_motion" type="text" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Proveedor</label>
                        <div class="field-control">
                          <input v-model.trim="vendor" type="text" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Valor del camión</label>
                        <div class="field-control">
                          <input v-model.number="truck_value" type="number" step="0.01" inputmode="decimal" />
                        </div>
                      </div>

                      <div class="field span-2">
                        <label class="field-label">Comentarios</label>
                        <div class="field-control">
                          <input v-model.trim="comments" type="text" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="maintenance-side">
                <div class="container-card">
                  <div class="section-title maintenance-title-row">
                    <h4>Información de equipo</h4>
                  </div>
                  <div class="container-card-body">
                    <div class="form-grid form-grid-single">
                      <div class="field">
                        <label class="field-label">Factura equipo</label>
                        <div class="field-control">
                          <input v-model.trim="equipment_invoice_number" type="text" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Año modelo equipo</label>
                        <div class="field-control">
                          <input v-model.number="equipment_model_year" type="number" inputmode="numeric" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Marca equipo</label>
                        <div class="field-control">
                          <input v-model.trim="equipment_brand" type="text" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Modelo equipo</label>
                        <div class="field-control">
                          <input v-model.trim="equipment_model" type="text" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Número de serie equipo</label>
                        <div class="field-control">
                          <input v-model.trim="equipment_serial_number" type="text" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Proveedor equipo</label>
                        <div class="field-control">
                          <input v-model.trim="equipment_vendor" type="text" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Pedimento equipo</label>
                        <div class="field-control">
                          <input v-model.trim="equipment_motion" type="text" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Fecha de compra equipo</label>
                        <div class="field-control">
                          <input v-model="equipment_buy_time" type="date" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Valor del equipo</label>
                        <div class="field-control">
                          <input v-model.number="equipment_value" type="number" step="0.01" inputmode="decimal" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Comentarios</label>
                        <div class="field-control">
                          <input v-model.trim="equipment_comments" type="text" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section v-else-if="activeTab === 'informative'">
            <div class="main-data-container single-column">
              <div class="maintenance-main">
                <div class="container-card">
                  <div class="section-title maintenance-title-row">
                    <h4>SCT. Carta Porte</h4>
                  </div>
                  <div class="container-card-body">
                    <div class="form-grid">
                      <div class="field">
                        <label class="field-label">Peso bruto (kg)</label>
                        <div class="field-control">
                          <input type="number" step="0.01" inputmode="decimal" v-model="gross_weight" placeholder="Ej. 12500.00" />
                        </div>
                      </div>
  
                      <div class="field">
                        <label class="field-label">Configuración vehicular</label>
                        <div class="field-control">
                          <input type="text" v-model.trim="vehicular_configuration" placeholder="Ej. C2, T3-S2-R4..." />
                        </div>
                      </div>
  
                      <div class="field">
                        <label class="field-label">Subtipo de remolque</label>
                        <div class="field-control">
                          <input type="text" v-model.trim="trailer_sub_type" placeholder="Ej. Lowboy, plataforma..." />
                        </div>
                      </div>
  
                      <div class="field">
                        <label class="field-label">Permiso SCT</label>
                        <div class="field-control">
                          <input type="text" v-model.trim="sct_permission" placeholder="Ej. SCT-XXXX" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="container-card">
                  <div class="section-title maintenance-title-row">
                    <h4>Pólizas</h4>
                  </div>
                  <div class="container-card-body">
                    <div class="form-grid">
                      <div class="field">
                        <label class="field-label">Aseguradora póliza flotilla</label>
                        <div class="field-control">
                          <input v-model.trim="fleet_policy_insurance" type="text" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Número póliza flotilla</label>
                        <div class="field-control">
                          <input v-model.trim="fleet_policy_number" type="text" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Cobertura póliza flotilla</label>
                        <div class="field-control">
                          <input v-model.trim="fleet_policy_coverage" type="text" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Vigencia póliza flotilla</label>
                        <div class="field-control">
                          <input v-model.trim="fleet_policy_validity" type="text" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Costo anual póliza flotilla</label>
                        <div class="field-control">
                          <input v-model.number="fleet_policy_annual_cost" type="number" step="0.01" inputmode="decimal" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Aseguradora póliza RC</label>
                        <div class="field-control">
                          <input v-model.trim="civil_liability_insurance" type="text" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Número póliza RC</label>
                        <div class="field-control">
                          <input v-model.trim="civil_liability_policy" type="text" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Vigencia póliza RC</label>
                        <div class="field-control">
                          <input v-model.trim="rc_policy_validity" type="text" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Costo anual póliza RC</label>
                        <div class="field-control">
                          <input v-model.number="rc_policy_annual_cost" type="number" step="0.01" inputmode="decimal" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="container-card">
                  <div class="section-title maintenance-title-row">
                    <h4>Verificaciones</h4>
                    <button type="button" class="btn ghost mini-action-btn" @click="addVerification">Agregar</button>
                  </div>
                  <div class="container-card-body">
                    <div v-for="(verification, index) in verificationsList" :key="`verification-${index}`" class="list-row">
                      <div class="field">
                        <label class="field-label">Tipo</label>
                        <div class="field-control">
                          <input v-model.trim="verification.type" type="text" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Folio</label>
                        <div class="field-control">
                          <input v-model.trim="verification.folio" type="text" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Fecha verificación</label>
                        <div class="field-control">
                          <input v-model="verification.verification_date" type="date" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Periodo</label>
                        <div class="field-control">
                          <input v-model.trim="verification.period" type="text" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Vencimiento</label>
                        <div class="field-control">
                          <input v-model="verification.expiration" type="date" />
                        </div>
                      </div>
                      <button type="button" class="btn remove-item-btn" @click="removeVerification(index)">Quitar</button>
                    </div>
                  </div>
                </div>

                <div class="container-card">
                  <div class="section-title maintenance-title-row">
                    <h4>Arrendamientos</h4>
                    <button type="button" class="btn ghost mini-action-btn" @click="addLease">Agregar</button>
                  </div>
                  <div class="container-card-body">
                    <div v-for="(lease, index) in leasesList" :key="`lease-${index}`" class="list-row">
                      <div class="field">
                        <label class="field-label">Arrendadora</label>
                        <div class="field-control">
                          <input v-model.trim="lease.lessor" type="text" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">No. contrato</label>
                        <div class="field-control">
                          <input v-model.trim="lease.contract_number" type="text" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Inicio</label>
                        <div class="field-control">
                          <input v-model="lease.start_date" type="date" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Término</label>
                        <div class="field-control">
                          <input v-model="lease.end_date" type="date" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Monto mensualidad</label>
                        <div class="field-control">
                          <input v-model.number="lease.monthly_amount" type="number" step="0.01" inputmode="decimal" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Monto opción a compra</label>
                        <div class="field-control">
                          <input v-model.number="lease.purchase_option_amount" type="number" step="0.01" inputmode="decimal" />
                        </div>
                      </div>
                      <button type="button" class="btn remove-item-btn" @click="removeLease(index)">Quitar</button>
                    </div>
                  </div>
                </div>

                <div class="container-card">
                  <div class="section-title maintenance-title-row">
                    <h4>Certificaciones</h4>
                  </div>
                  <div class="container-card-body">
                    <div class="field">
                      <label class="field-label">¿Esta unidad requiere certificaciones?</label>
                      <div class="field-control">
                        <div class="toggle">
                          <input
                            id="enable-certifications"
                            type="checkbox"
                            v-model="enable_certifications"
                            @change="onEnableCertificationsChange"
                          />
                          <label for="enable-certifications">Habilitar certificaciones</label>
                        </div>
                      </div>
                      <p class="field-hint">
                        Al activarla aparece la sección para registrar certificaciones. Los documentos se adjuntan al editar la unidad.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section v-else-if="activeTab === 'certifications'">
            <div class="main-data-container single-column">
              <div class="maintenance-main">
                <div class="container-card">
                  <div class="section-title maintenance-title-row">
                    <h4>Certificaciones</h4>
                    <button type="button" class="btn ghost mini-action-btn" @click="addCertification">Agregar</button>
                  </div>
                  <div class="container-card-body">
                    <p class="field-hint">
                      Registra el nombre, la fecha de obtención, el vencimiento y comentarios. Los documentos se pueden subir después, al editar la unidad.
                    </p>
                    <div v-for="(cert, index) in certificationsList" :key="cert.id" class="cert-block">
                      <div class="cert-block-head">
                        <h5>{{ cert.name || "Nueva certificación" }}</h5>
                        <span v-if="certificationStatus(cert) === 'Vencida'" class="pill danger">Vencida</span>
                        <span v-else-if="certificationStatus(cert) === 'Vigente'" class="pill ok">Vigente</span>
                        <button type="button" class="btn remove-item-btn" @click="removeCertification(index)">Quitar</button>
                      </div>
                      <div class="form-grid">
                        <div class="field">
                          <label class="field-label">Nombre</label>
                          <div class="field-control">
                            <input v-model.trim="cert.name" type="text" placeholder="Ej. Certificación cliente X" />
                          </div>
                        </div>
                        <div class="field">
                          <label class="field-label">Fecha de obtención</label>
                          <div class="field-control">
                            <input v-model="cert.obtained_date" type="date" />
                          </div>
                        </div>
                        <div class="field">
                          <label class="field-label">Vencimiento</label>
                          <div class="field-control">
                            <input v-model="cert.expiration" type="date" />
                          </div>
                        </div>
                        <div class="field span-2">
                          <label class="field-label">Comentarios</label>
                          <div class="field-control">
                            <textarea v-model.trim="cert.comments" placeholder="Notas sobre esta certificación"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
  
          <section v-else-if="activeTab === 'bajas'">
            <div class="main-data-container single-column">
              <div class="maintenance-main">
                <div class="container-card">
                  <div class="section-title maintenance-title-row">
                    <h4>Información de baja</h4>
                    <div class="pill danger">Baja</div>
                  </div>
                  <div class="container-card-body">
                    <div class="form-grid form-grid-single">
                      <div class="field">
                        <label class="field-label">¿Está dada de baja?</label>
                        <div class="field-control">
                          <div class="toggle">
                            <input id="deco" type="checkbox" v-model="is_decomissioned" />
                            <label for="deco">BAJA</label>
                          </div>
                        </div>
                      </div>
  
                      <div class="field">
                        <label class="field-label">Fecha de baja</label>
                        <div class="field-control">
                          <input v-model="decomission_time" type="datetime-local" :disabled="!is_decomissioned" />
                        </div>
                      </div>
  
                      <div class="field">
                        <label class="field-label">Razón</label>
                        <div class="field-control">
                          <input v-model.trim="decomission_reason" type="text" :disabled="!is_decomissioned" />
                        </div>
                      </div>
  
                      <div class="field">
                        <label class="field-label">Comprador</label>
                        <div class="field-control">
                          <input v-model.trim="buyer" type="text" :disabled="!is_decomissioned" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Vendedor</label>
                        <div class="field-control">
                          <input v-model.trim="decomission_seller" type="text" :disabled="!is_decomissioned" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Número de factura</label>
                        <div class="field-control">
                          <input v-model.trim="decomission_invoice_number" type="text" :disabled="!is_decomissioned" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Valor factura</label>
                        <div class="field-control">
                          <input v-model.number="decomission_invoice_value" type="number" step="0.01" inputmode="decimal" :disabled="!is_decomissioned" />
                        </div>
                      </div>

                      <div class="field">
                        <label class="field-label">Valor real de venta</label>
                        <div class="field-control">
                          <input v-model.trim="decomission_real_sale_value" type="text" :disabled="!is_decomissioned" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
  
      <!-- Bottom actions (mobile friendly) -->
      <footer class="savebar">
        <div class="savebar-left">
          <span class="dot" :class="{ dirty: isDirty }"></span>
          <span class="savebar-text">
            <b v-if="isDirty">Cambios sin guardar</b>
            <span v-else>Listo para guardar</span>
          </span>
        </div>
        <div class="savebar-actions">
          <button class="btn ghost" type="button" @click="resetAll" :disabled="saving_unit || !isDirty">
            Descartar
          </button>
          <button
            v-if="canCreateUnit"
            class="btn primary"
            type="button"
            @click="saveUnit"
            :disabled="saving_unit || !isFormValid"
          >
            <span v-if="!saving_unit">Guardar</span>
            <span v-else>Guardando…</span>
          </button>
        </div>
      </footer>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import Swal from "sweetalert2";
  
  export default {
    name: "CreateUnitModern",
    data() {
      return {
        permissions: [],
        saving_unit: false,
        activeTab: "general",
        pristineSnapshot: "",
  
        // BASIC
        unit_id: "",
        unit_short_id: "",
        unit_owner: "",
        unit_plates: "",
        unit_engine_num: "",
        unit_brand: "",
        unit_sub_brand: "",
        unit_model: "",
        unit_class: "",
        unit_type: "",
        unit_category: "",
        gps_id: "",
        comments: "",
  
        // STATUS (kept like your original defaults)
        unit_status: 1,
        unit_deleted: "2",
  
        // REGULATORY (kept your defaults)
        civil_liability_insurance: "",
        civil_liability_policy: "",
        gross_weight: "",
        trailer_sub_type: "",
        vehicular_configuration: "",
        sct_permission: "",
  
        // ADMIN (new model fields)
        buy_time: null,
        current_total_value: null,
        value_update_time: null,
        invoice_owner: null,
        assigned_owner: null,
        vendor: "",
  
        // TRUCK
        truck_type: "",
        engine_type: "",
        invoice_number: "",
        truck_value: null,
        truck_motion: "",
  
        // EQUIPMENT
        equipment_model_year: null,
        equipment_invoice_number: "",
        equipment_brand: "",
        equipment_model: "",
        equipment_vendor: "",
        equipment_serial_number: "",
        equipment_buy_time: null,
        equipment_motion: "",
        equipment_value: null,
        equipment_comments: "",
  
        // DECOMISSION
        is_decomissioned: false,
        decomission_time: null,
        decomission_reason: "",
        buyer: "",
        decomission_seller: "",
        decomission_invoice_number: "",
        decomission_invoice_value: null,
        decomission_real_sale_value: "",

        // INFORMATIVE
        fleet_policy_insurance: "",
        fleet_policy_number: "",
        fleet_policy_coverage: "",
        fleet_policy_validity: "",
        fleet_policy_annual_cost: null,
        rc_policy_validity: "",
        rc_policy_annual_cost: null,
        verificationsList: [{ type: "", folio: "", verification_date: "", period: "", expiration: "" }],
        leasesList: [{ lessor: "", contract_number: "", start_date: "", end_date: "", monthly_amount: "", purchase_option_amount: "" }],
        enable_certifications: false,
        certificationsList: [],
  
        // tabs
        tabs: [
          { key: "general", label: "DATOS GENERALES", hint: "UNIDAD / ADMINISTRATIVO / ESTADO" },
          { key: "truck", label: "CAMIÓN / EQUIPO", hint: "CAMIÓN / EQUIPO" },
          { key: "informative", label: "INFORMATIVO", hint: "SCT / PÓLIZAS / VERIFICACIONES / ARRENDAMIENTOS" },
          { key: "bajas", label: "BAJAS", hint: "INFORMACIÓN DE BAJA" },
        ],
      };
    },
    computed: {
      canCreateUnit() {
        return this.hasAnyPerm(["maintenance.create_unit", "ui_access_units_create"]);
      },
      isFormValid() {
        // kept your original validation intent, but not blocking on the "extra" new tabs
        // (so you can create a basic unit quickly)
        return (
          this.unit_id !== "" &&
          this.unit_short_id !== "" &&
          this.unit_owner !== "" &&
          this.unit_plates !== "" &&
          this.unit_engine_num !== "" &&
          this.unit_brand !== "" &&
          this.unit_sub_brand !== "" &&
          this.unit_model !== "" &&
          this.unit_class !== "" &&
          this.unit_type !== "" &&
          this.unit_category !== "" &&
          this.unit_status !== "" &&
          this.unit_deleted !== ""
        );
      },
      isDirty() {
        return JSON.stringify(this.buildUnitData()) !== this.pristineSnapshot;
      },
      visibleTabs() {
        if (!this.enable_certifications) return this.tabs;
        const tabs = [...this.tabs];
        const informativeIndex = tabs.findIndex((tab) => tab.key === "informative");
        tabs.splice(informativeIndex + 1, 0, {
          key: "certifications",
          label: "CERTIFICACIONES",
          hint: "NOMBRE / VIGENCIA / COMENTARIOS",
        });
        return tabs;
      },
    },
    created() {
      this.pristineSnapshot = JSON.stringify(this.buildUnitData());
    },
    mounted() {
      this.loadPermissions();
      if (!this.canCreateUnit) {
        this.$router.push({ name: "MainPanel" });
      }
    },
    methods: {
      loadPermissions() {
        try {
          this.permissions = JSON.parse(localStorage.getItem("userPermissions")) || [];
        } catch (error) {
          this.permissions = [];
        }
      },
      hasPerm(perm) {
        if (!perm) return false;
        if (this.permissions.includes(perm)) return true;
        return this.permissions.includes(`access_control.${perm}`);
      },
      hasAnyPerm(perms) {
        if (!Array.isArray(perms) || perms.length === 0) return false;
        return perms.some((perm) => this.hasPerm(perm));
      },
      backMainPanel() {
        window.location.href = "/main-panel";
      },
      goBack() {
        history.back();
      },
      resetAll() {
        const snap = JSON.parse(this.pristineSnapshot || "{}");
        Object.keys(snap).forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(this.$data, key)) this[key] = snap[key];
        });
        this.verificationsList = this.normalizeList(
          snap.verifications,
          ["type", "folio", "verification_date", "period", "expiration"],
          () => ({ type: "", folio: "", verification_date: "", period: "", expiration: "" }),
        );
        this.leasesList = this.normalizeList(
          snap.leases,
          ["lessor", "contract_number", "start_date", "end_date", "monthly_amount", "purchase_option_amount"],
          () => ({ lessor: "", contract_number: "", start_date: "", end_date: "", monthly_amount: "", purchase_option_amount: "" }),
        );
        this.certificationsList = this.normalizeCertifications(snap.certifications);
        this.activeTab = "general";
        this.saving_unit = false;
      },
      normalizeList(value, keys, factory) {
        if (Array.isArray(value) && value.length) {
          return value.map((item) => {
            const normalized = {};
            keys.forEach((key) => {
              normalized[key] = (item && item[key]) || "";
            });
            return normalized;
          });
        }
        return [factory()];
      },
      newCertificationId() {
        if (window.crypto && typeof window.crypto.randomUUID === "function") {
          return window.crypto.randomUUID();
        }
        return `cert-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      },
      defaultCertification() {
        return {
          id: this.newCertificationId(),
          name: "",
          obtained_date: "",
          expiration: "",
          comments: "",
        };
      },
      normalizeCertifications(value) {
        if (Array.isArray(value) && value.length) {
          return value.map((item) => ({
            id: (item && item.id) || this.newCertificationId(),
            name: (item && item.name) || "",
            obtained_date: (item && item.obtained_date) || "",
            expiration: (item && item.expiration) || "",
            comments: (item && item.comments) || "",
          }));
        }
        return [this.defaultCertification()];
      },
      sanitizeCertifications(list) {
        const cleaned = (list || [])
          .map((item) => ({
            id: item.id,
            name: (item.name ?? "").toString().trim(),
            obtained_date: (item.obtained_date ?? "").toString().trim(),
            expiration: (item.expiration ?? "").toString().trim(),
            comments: (item.comments ?? "").toString().trim(),
          }))
          .filter((item) => item.id && (item.name || item.obtained_date || item.expiration || item.comments));
        return cleaned.length ? cleaned : null;
      },
      certificationStatus(cert) {
        if (!cert || !cert.expiration) return "";
        const now = new Date();
        const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
        return cert.expiration < today ? "Vencida" : "Vigente";
      },
      onEnableCertificationsChange() {
        if (this.enable_certifications) {
          if (!this.certificationsList.length) this.certificationsList.push(this.defaultCertification());
          this.activeTab = "certifications";
          return;
        }
        if (this.activeTab === "certifications") this.activeTab = "informative";
      },
      addCertification() {
        this.certificationsList.push(this.defaultCertification());
      },
      removeCertification(index) {
        this.certificationsList.splice(index, 1);
        if (!this.certificationsList.length) this.certificationsList.push(this.defaultCertification());
      },
      sanitizeList(list, keys) {
        const cleaned = list
          .map((item) => {
            const normalized = {};
            keys.forEach((key) => {
              normalized[key] = (item[key] ?? "").toString().trim();
            });
            return normalized;
          })
          .filter((item) => keys.some((key) => item[key]));
        return cleaned.length ? cleaned : null;
      },
      normalizeDateInput(value) {
        if (!value) return "";
        const match = String(value).trim().match(/^(\d{4}-\d{2}-\d{2})/);
        return match ? match[1] : "";
      },
      serializeDateForApi(value) {
        const normalized = this.normalizeDateInput(value);
        return normalized ? `${normalized}T00:00:00` : null;
      },
      addVerification() {
        this.verificationsList.push({ type: "", folio: "", verification_date: "", period: "", expiration: "" });
      },
      removeVerification(index) {
        this.verificationsList.splice(index, 1);
        if (!this.verificationsList.length) this.verificationsList.push({ type: "", folio: "", verification_date: "", period: "", expiration: "" });
      },
      addLease() {
        this.leasesList.push({ lessor: "", contract_number: "", start_date: "", end_date: "", monthly_amount: "", purchase_option_amount: "" });
      },
      removeLease(index) {
        this.leasesList.splice(index, 1);
        if (!this.leasesList.length) this.leasesList.push({ lessor: "", contract_number: "", start_date: "", end_date: "", monthly_amount: "", purchase_option_amount: "" });
      },
  
      // IMPORTANT: saving logic preserved (we still build unitData and POST it)
      buildUnitData() {
        return {
          unit_id: this.unit_id,
          unit_short_id: this.unit_short_id,
          unit_owner: this.unit_owner,
          unit_plates: this.unit_plates,
          unit_engine_num: this.unit_engine_num,
          unit_brand: this.unit_brand,
          unit_sub_brand: this.unit_sub_brand,
          unit_model: this.unit_model,
          unit_class: this.unit_class,
          unit_type: this.unit_type,
          unit_category: this.unit_category,
          gps_id: this.gps_id,
          comments: this.comments,
          unit_status: this.unit_status,
          unit_deleted: this.unit_deleted,
  
          civil_liability_insurance: this.civil_liability_insurance,
          civil_liability_policy: this.civil_liability_policy,
          gross_weight: this.gross_weight,
          trailer_sub_type: this.trailer_sub_type,
          vehicular_configuration: this.vehicular_configuration,
          sct_permission: this.sct_permission,
  
          // new model fields
          buy_time: this.serializeDateForApi(this.buy_time),
          current_total_value: this.current_total_value,
          value_update_time: this.serializeDateForApi(this.value_update_time),
          invoice_owner: this.invoice_owner,
          assigned_owner: this.assigned_owner,
          vendor: this.vendor,
  
          truck_type: this.truck_type,
          engine_type: this.engine_type,
          invoice_number: this.invoice_number,
          truck_value: this.truck_value,
          truck_motion: this.truck_motion,
  
          equipment_model_year: this.equipment_model_year,
          equipment_invoice_number: this.equipment_invoice_number,
          equipment_brand: this.equipment_brand,
          equipment_model: this.equipment_model,
          equipment_vendor: this.equipment_vendor,
          equipment_serial_number: this.equipment_serial_number,
          equipment_buy_time: this.serializeDateForApi(this.equipment_buy_time),
          equipment_motion: this.equipment_motion,
          equipment_value: this.equipment_value,
          equipment_comments: this.equipment_comments,
  
          is_decomissioned: this.is_decomissioned,
          decomission_time: this.decomission_time,
          decomission_reason: this.decomission_reason,
          buyer: this.buyer,
          decomission_seller: this.decomission_seller,
          decomission_invoice_number: this.decomission_invoice_number,
          decomission_invoice_value: this.decomission_invoice_value,
          decomission_real_sale_value: this.decomission_real_sale_value,

          fleet_policy_insurance: this.fleet_policy_insurance,
          fleet_policy_number: this.fleet_policy_number,
          fleet_policy_coverage: this.fleet_policy_coverage,
          fleet_policy_validity: this.fleet_policy_validity,
          fleet_policy_annual_cost: this.fleet_policy_annual_cost,
          rc_policy_validity: this.rc_policy_validity,
          rc_policy_annual_cost: this.rc_policy_annual_cost,
          verifications: this.sanitizeList(this.verificationsList, ["type", "folio", "verification_date", "period", "expiration"]),
          leases: this.sanitizeList(this.leasesList, ["lessor", "contract_number", "start_date", "end_date", "monthly_amount", "purchase_option_amount"]),
          enable_certifications: !!this.enable_certifications,
          certifications: this.sanitizeCertifications(this.certificationsList),
        };
      },
  
      async saveUnit() {
        try {
          if (!this.canCreateUnit) {
            Swal.fire("Sin acceso", "No tienes permisos para crear unidades.", "warning");
            return;
          }
          const apiDirectory = process.env.API_DIRECTORY;
  
          // SAME logic as your original: build unitData and post it
          const unitData = this.buildUnitData();
          console.log(unitData);
  
          this.saving_unit = true;
          await axios.post(`${apiDirectory}/create-unit`, unitData, {
            headers: { "Content-Type": "application/json" },
          });
  
          Swal.fire("¡Guardado!", "Los datos del formulario se han guardado con éxito.", "success").then(() => {
            this.$router.push({ name: "MaintenanceModule" });
          });
        } catch (error) {
          Swal.fire("Error", "Verifique que los datos que está ingresando son válidos", "error");
        } finally {
          this.saving_unit = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .unit-editor {
    min-height: 100vh;
    background: #e9edf5;
    color: #0f172a;
  }
  
  /* Topbar */
  .topbar {
    position: sticky;
    top: 0;
    z-index: 20;
    min-height: 64px;
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 8px 14px;
    background: #ffc434;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.16);
  }
  
  .logo-button {
    height: 46px;
    cursor: pointer;
  }
  
  .topbar-title {
    display: flex;
    flex-direction: column;
    line-height: 1.1;
  }
  
  .kicker {
    font-size: 12px;
    opacity: 0.75;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: uppercase;
  }
  
  .topbar-title h1 {
    margin: 0;
    font-size: 18px;
    font-weight: 900;
  }
  
  .subtitle {
    margin: 2px 0 0;
    font-size: 12px;
    opacity: 0.8;
  }
  
  .topbar-actions {
    margin-left: auto;
    display: flex;
    gap: 10px;
  }
  
  /* Tabs area */
  .tabs-wrap {
    max-width: 1280px;
    margin: 10px auto 76px;
    padding: 0 16px;
  }
  
  .tabs {
    display: flex;
    gap: 8px;
    overflow: auto;
    padding-bottom: 4px;
    scrollbar-width: thin;
  }
  
  .tab {
    border: 1px solid #94a3b8;
    background: #f8fafc;
    border-radius: 10px;
    padding: 8px 10px;
    min-width: 138px;
    text-align: left;
    cursor: pointer;
    transition: transform 120ms ease, box-shadow 120ms ease;
  }
  
  .tab:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 18px rgba(15, 23, 42, 0.08);
  }
  
  .tab.active {
    border-color: #1d4ed8;
    background: #dbeafe;
    box-shadow: 0 6px 14px rgba(29, 78, 216, 0.22);
  }
  
  .tab-label {
    display: block;
    font-weight: 900;
    font-size: 12px;
  }
  
  .tab-hint {
    display: block;
    font-size: 10px;
    opacity: 0.82;
    margin-top: 2px;
  }
  
  /* Tab content layout */
  .tab-panel {
    margin-top: 10px;
  }
  
  .main-data-container {
    display: grid;
    grid-template-columns: repeat(14, minmax(0, 1fr));
    gap: 10px;
  }

  .main-data-container.single-column {
    grid-template-columns: 1fr;
  }

  .maintenance-main {
    grid-column: span 10;
    display: grid;
    gap: 10px;
  }

  .maintenance-side {
    grid-column: span 4;
    display: grid;
    gap: 10px;
  }

  .main-data-container.single-column .maintenance-main,
  .main-data-container.single-column .maintenance-side {
    grid-column: 1 / -1;
  }

  .container-card {
    background: #fff;
    border: 1px solid #cbd5e1;
    border-radius: 0;
    border-top: none;
    box-shadow: 0 4px 10px rgba(15, 23, 42, 0.08);
  }
  
  .section-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 8px;
    border-bottom: 1px solid #cbd5e1;
    background: #dbe3ef;
  }

  .maintenance-title-row {
    gap: 10px;
  }
  
  .section-title h4 {
    margin: 0;
    font-size: 13px;
    font-weight: 800;
  }
  
  .container-card-body {
    padding: 8px;
  }
  
  .container-card-body p {
    margin: 2px 0 0;
    font-size: 12px;
    opacity: 0.75;
  }

  @media (max-width: 1120px) {
    .main-data-container {
      grid-template-columns: 1fr;
    }

    .maintenance-main,
    .maintenance-side {
      grid-column: 1 / -1;
    }
  }
  
  /* Pills */
  .pill {
    display: inline-flex;
    align-items: center;
    height: 22px;
    padding: 0 8px;
    border-radius: 999px;
    background: #c7d2fe;
    color: #1e3a8a;
    font-weight: 900;
    font-size: 11px;
  }
  
  .pill.danger {
    background: #fecaca;
    color: #991b1b;
  }

  .pill.ok {
    background: #bbf7d0;
    color: #166534;
  }

  .field-hint {
    margin: 8px 0 0;
    font-size: 12px;
    color: #475569;
  }

  .cert-block {
    padding: 12px 0;
    border-bottom: 1px solid #dbe3ef;
  }

  .cert-block:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  .cert-block-head {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
  }

  .cert-block-head h5 {
    margin: 0;
    flex: 1;
    font-size: 13px;
    font-weight: 900;
  }
  
  /* Form grid */
  .form-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
  }

  .form-grid-single {
    grid-template-columns: 1fr;
  }

  @media (max-width: 1400px) {
    .form-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .form-grid-single {
      grid-template-columns: 1fr;
    }
  }
  
  @media (max-width: 900px) {
    .form-grid {
      grid-template-columns: 1fr;
    }

    .form-grid-single {
      grid-template-columns: 1fr;
    }
  }
  
  /* Field wrapper */
  .field {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .field-label {
    font-size: 11px;
    font-weight: 900;
    opacity: 0.95;
    color: #0f172a;
  }
  
  .field-control input,
  .field-control select,
  .field-control textarea {
    width: 100%;
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid #94a3b8;
    background: #fff;
    outline: none;
    transition: box-shadow 120ms ease, border-color 120ms ease;
    font-size: 12px;
  }
  
  .field-control input:focus,
  .field-control select:focus,
  .field-control textarea:focus {
    border-color: #1d4ed8;
    box-shadow: 0 0 0 3px rgba(29, 78, 216, 0.18);
  }

  .field-control textarea {
    min-height: 76px;
    resize: vertical;
  }

  .list-row {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr)) auto;
    gap: 10px;
    align-items: end;
    padding: 8px 0;
    border-bottom: 1px solid #dbe3ef;
  }

  .list-row:last-child {
    border-bottom: none;
  }

  .mini-action-btn {
    padding: 4px 10px;
    font-size: 11px;
  }

  .remove-item-btn {
    padding: 6px 10px;
    font-size: 11px;
    background: #ef4444;
    color: #fff;
    border-color: #dc2626;
  }
  
  .span-2 {
    grid-column: span 3;
  }

  @media (max-width: 1400px) {
    .span-2 {
      grid-column: span 2;
    }
  }
  
  @media (max-width: 900px) {
    .span-2 {
      grid-column: span 1;
    }

    .list-row {
      grid-template-columns: 1fr;
      align-items: stretch;
    }
  }
  
  /* Toggle */
  .toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 8px;
    border-radius: 8px;
    border: 1px dashed #64748b;
    background: #eef2ff;
  }
  
  .toggle input {
    width: 18px;
    height: 18px;
  }
  
  /* Buttons */
  .btn {
    border: 1px solid #64748b;
    border-radius: 8px;
    padding: 8px 10px;
    font-weight: 900;
    font-size: 12px;
    cursor: pointer;
    transition: transform 120ms ease, box-shadow 120ms ease;
  }
  
  .btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
  
  .btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 10px 18px rgba(15, 23, 42, 0.10);
  }
  
  .btn.primary {
    background: #1d4ed8;
    color: #fff;
    border-color: #1e40af;
  }
  
  .btn.ghost {
    background: #e2e8f0;
  }
  
  /* Savebar */
  .savebar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 25;
    background: rgba(226, 232, 240, 0.96);
    backdrop-filter: blur(10px);
    border-top: 1px solid #94a3b8;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 14px;
  }
  
  .savebar-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .dot {
    width: 10px;
    height: 10px;
    border-radius: 999px;
    background: rgba(15, 23, 42, 0.25);
  }
  
  .dot.dirty {
    background: #ffc434;
    box-shadow: 0 0 0 6px rgba(255, 196, 52, 0.22);
  }
  
  .savebar-text {
    font-size: 12px;
    opacity: 0.9;
  }
  
  .savebar-actions {
    display: flex;
    gap: 10px;
  }
  </style>